/* global eventHub */
/* eslint no-undef: "error" */
import CstSurveyBaseDeck from './CstSurveyBaseDeck'
import CstCustomerDataDeck from './CstCustomerDataDeck'
import store from '@/components/store.js'
import axios from 'axios'
import Vue from 'vue'
// import router from './../router'
import { i18n } from '@/components/i18n.js'
import { invert } from '../utils.js'

export default function CstSurvey () {
  var self = this

  var answers = []

  var reviews = {}

  var base_url = 'https://hotel-barometer.com/survey-endpoint.php'
  // var base_url = 'https://barometer.cst.local.w.og.vioma.de/survey-endpoint.php'
  var survey_base_url = 'https://hotel-barometer.com/survey'
  // var survey_base_url = 'https://barometer.cst.local.w.og.vioma.de/survey'

  var current_card_position = 0

  var survey_id = '0'

  var survey_key = 'abc'

  var hotel_id = 0

  var loaded_extended_questionaire = false

  var decks = []
  var cards = []
  var current_deck_index = 0

  var external_questionaires = {}

  // var is_inited = false
  var is_first_survey_load = true
  var is_survey_data_loaded = false
  var is_first_hotel_data_load = true

  var language_lookup = {
    1: 'de',
    2: 'en',
    3: 'it',
    5: 'fr',
    8: 'es'
  }

  var locale = 'en'

  var usable_languages = [ 'de', 'en', 'it', 'fr', 'es' ]

  var addDeck = function (deck) {
    decks.push(deck)
    current_deck_index++
    //        eventHub.$emit('card-next');
  }

  var getBrowserLanguage = function () {
    let languages = window.navigator.languages || [window.navigator.language || window.navigator.userLanguage]
    for (var l in languages) {
      let language = languages[l].split('-')[0]
      if (usable_languages.indexOf(language) !== -1) {
        return language
      }
    }
    return false
  }

  var updateSurveyLanguage = function (locale) {
    return new Promise((resolve, reject) => {
      axios.get(base_url, {
        params: {
          type: 'survey_set_language',
          survey_id: store.state.surveyId,
          survey_key: store.state.surveyKey,
          language: locale
        }
      }).then(function (response) {
        resolve()
      })
    })
  }

  var setLocale = function (localeNew) {
    i18n.locale = localeNew
    locale = localeNew
    if (store) {
      store.commit('setLocale', localeNew)
    }
  }

  var changeLocale = function (localeNew) {
    return new Promise((resolve, reject) => {
      setLocale(localeNew)
      let actions = [getHotelData()]
      for (var d in decks) {
        var deck = decks[d]
        actions.push(deck.changeLocale(localeNew))
      }
      Promise.all(actions).then(() => resolve())
    })
  }

  var init = function () {
    let browserLocale = getBrowserLanguage()
    if (browserLocale) {
      setLocale(browserLocale)
    }
    hotel_id = getHotelIdFromUrl()
    eventHub.$on('deck-add', addDeck)
    self.answerQuestion = answerQuestion
    self.loadSurvey = loadSurvey
    self.loadExtendedSurvey = loadExtendedSurvey
    self.loadedExtendedQuestionaire = loaded_extended_questionaire
    self.updateSurveyLanguage = updateSurveyLanguage
    self.current_card = function () {
      return store.state.cards[store.state.current_card_position]
    }
  }
  var hotel_data = {
    images: {
      logo: '',
      header: ''
    },
    hotel: {
      languages: [],
      urls: {}
    }
  }

  var submitExternalSurvey = function (surveyData) {
    return new Promise((resolve, reject) => {
      var data_struct = {
        answers: {},
        hotel: surveyData.hotel
      }
      for (var x in surveyData.answers) {
        var entry = surveyData.answers[x]
        if (entry.value != null) {
          data_struct.answers[entry.field_name] = entry.value
        }
      }
      for (var key in surveyData.mappedValues) {
        if (!data_struct.answers[key]) {
          data_struct.answers[key] = surveyData.mappedValues[key]
        }
      }
      axios.request(base_url, {
        method: 'post',
        params: {
          type: 'survey_submit_external',
          survey_id: store.state.surveyId,
          survey_key: store.state.surveyKey,
          survey_type: surveyData.surveyType
        },
        data: data_struct
      }).then(function (response) {
        resolve(response.data)
      })
    })
  }

  var loadSurvey = function (survey_id, survey_key, language) {
    return new Promise((resolve, reject) => {
      axios.get(base_url, {
        params: {
          type: 'survey_get',
          survey_id: survey_id,
          survey_key: survey_key,
          language: language
        }
      }).then(function (response) {
        initSurveyData(response.data)

        if (is_first_survey_load && language_lookup[response.data.survey.survey_language * 1] !== locale) {
          setLocale(language_lookup[response.data.survey.survey_language * 1])
        }

        // todo: das ist nur n tmp check..
        if (decks.length) {
          decks[0].mergeDeck(response.data.questionaire)
        } else {
          let survey_deck = new CstSurveyBaseDeck(self, response.data)
          decks.push(survey_deck)
        }
        is_survey_data_loaded = true
        is_first_survey_load = false
        resolve()
      })
    })
  }

  var initSurveyData = function (data) {
    store.state.answers = data.answers
    store.state.customer = data.customer
    store.state.visit = data.visit
    store.state.visit_modules = data.visit_modules
    store.state.selectedModules = data.visit_modules
    store.state.reviews = data.reviews
    store.state.surveyId = data.survey.survey_id
    store.state.surveyKey = data.survey.survey_key
    store.state.questionaire = data.questionaire
  }

  var answerQuestion = function (answer) {
    var answer_out = {
      answer: {
        question: answer.questionId,
        value: answer.answerValue,
        id: answer.answerId,
        score: answer.answerScore,
        text: answer.answerText
      }
    }

    return new Promise((resolve, reject) => {
      axios.request(base_url, {
        method: 'post',
        params: {
          type: 'survey_answer',
          survey_id: store.state.surveyId,
          survey_key: store.state.surveyKey
        },
        data: answer_out
      }).then(function (response) {
        resolve()
      })
    })
  }

  var createSurvey = function (customer, visit) {
    let customer_out = {
      language: this.languageLookupReverse[this.locale]
    }
    let visit_out = {}

    for (var cKey in customer) {
      customer_out[cKey] = customer[cKey].value || ''
    }

    for (var vKey in visit) {
      visit_out[vKey] = visit[vKey].value || ''
    }

    return new Promise((resolve, reject) => {
      axios.request(base_url, {
        method: 'post',
        params: {
          type: 'hotel_survey_create',
          hotel_id: store.state.hotelId,
          language: store.state.locale
        },
        data: {
          customer: customer_out,
          visit: visit_out
        }
      }).then(function (response) {
        let survey_url = `${survey_base_url}/hotel/${store.state.hotelId}/survey/${response.data.survey_id}/${response.data.survey_key}`
        window.location.replace(survey_url)
      })
    })
  }

  var startSurvey = function () {
    return axios.get(base_url, {
      params: {
        type: 'survey_start',
        survey_id: store.state.surveyId,
        survey_key: store.state.surveyKey
      }
    })
  }

  var finishSurvey = function () {
    if (store.state.is_survey_finished) {
      Promise.resolve()
    }
    return new Promise((resolve, reject) => {
      axios.get(base_url, {
        params: {
          type: 'survey_finish',
          survey_id: store.state.surveyId,
          survey_key: store.state.surveyKey
        }
      }).then(function (response) {
        store.state.is_survey_finished = true
        resolve()
      })
    })
  }

  var loadExtendedSurvey = function (filters, merge_into_current_deck = true) {
    return new Promise((resolve, reject) => {
      axios.get(base_url, {
        params: {
          type: 'survey_load_extended',
          survey_id: store.state.surveyId,
          survey_key: store.state.surveyKey,
          language: store.state.locale,
          hotel: store.state.hotelId,
          filters: filters
        }
      }).then(function (response) {
        if (merge_into_current_deck) {
          decks[0].mergeDeck(response.data)
        } else {
          let survey_deck = new CstSurveyBaseDeck(self, { questionaire: response.data })
          decks.push(survey_deck)
        }
        store.state.loadedExtendedQuestionaire = true
        resolve()
      })
    })
  }

  function hexToRgb (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null
  }

  var updateLayout = function (layout) {
    updateStyles(layout.theme)
  }

  var updateStyles = function (styles) {
    var placeHolderMapping = {
      'main-button-color': '#9F9E9D',
      'arrow-color': '#9D9F9E'
      // 'secondary-button-color': '#BDBDBD',
      // 'tertiary-button-color': '#737373',
      // 'main-headline-color': '#1F97B8',
      // 'item-active-color': '#E5F5FB',
      // 'border-color': '#cccccc',
      // 'text-color': '#5c5c5c'
    }

    var rgbLookup = {}

    for (var placeholder in placeHolderMapping) {
      var placeHolderValue = placeHolderMapping[placeholder]
      rgbLookup[placeHolderValue] = styles[placeholder].color
    }
    for (var sheetIndex in window.document.styleSheets) {
      var sheet = window.document.styleSheets[sheetIndex]
      try {
        for (var x = 0; x < sheet.cssRules.length; x++) {
          var rule = sheet.cssRules[x]
          try {
            for (var y = 0; y < rule.style.length; y++) {
              var attrKey = rule.style[y]
              var styleContent = rule.style[attrKey]
              for (var ph in rgbLookup) {
                var rgb = hexToRgb(ph)
                var rgbStr = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`
                var rgbaStr = `rgba(${rgb.r}, ${rgb.g}, ${rgb.b},`
                if (styleContent.indexOf(rgbStr) === 0) {
                  rule.style[attrKey] = rgbLookup[ph]
                } else if (styleContent.toLowerCase() === ph.toLowerCase()) {
                  rule.style[attrKey] = rgbLookup[ph]
                } else if (styleContent.indexOf(rgbaStr) === 0) {
                  var currentAlpha = styleContent.slice(1, -1).split(',')[3]
                  var rgbNew = hexToRgb(rgbLookup[ph])
                  var rgbaReplace = `rgba(${rgbNew.r}, ${rgbNew.g}, ${rgbNew.b},${currentAlpha})`
                  rule.style[attrKey] = rgbaReplace
                }
              }
            }
          } catch (e) {}
        }
      } catch (e) {
      }
    }
  }

  var getHotelData = function (hotel_id_in) {
    return new Promise((resolve, reject) => {
      axios.get(base_url, {
        params: {
          type: 'hotel_data',
          hotel_id: hotel_id,
          language: locale
        }
      }).then(function (response) {
        usable_languages = response.data.hotel.languages
        if (is_first_hotel_data_load) {
          // nur fuer dev, prod hat ne statische css datei
          // da reicht settimeout
          // window.setInterval(function () { updateLayout(response.data.layout) }, 1000)
          window.setTimeout(function () { updateLayout(response.data.layout) }, 1)
          if (!is_survey_data_loaded) {
            let browserLanguage = getBrowserLanguage()
            // browsersprache verfuegbar aber nicht gewaehlt
            if (browserLanguage && locale !== browserLanguage) {
              changeLocale(browserLanguage)
            } else if (!browserLanguage && usable_languages.indexOf(locale) === -1) {
              changeLocale(usable_languages[0])
            }
          }
        }
        is_first_hotel_data_load = false
        store.commit('setHotelData', response.data)
        resolve()
      })
    })
  }

  var initSurvey = function () {
    var surveyUrlData = getSurveyTypefromUrl()
    if (surveyUrlData.type === 'survey-existing') {
      return loadSurvey(surveyUrlData.id, surveyUrlData.key).then(() => { store.dispatch('getHotelData').then(startSurvey) })
    } else if (surveyUrlData.type === 'survey-new') {
      return new Promise((resolve, reject) => {
        store.dispatch('getHotelData').then(() => {
          let customer_deck = new CstCustomerDataDeck(self, store.state.hotelData)
          Vue.set(decks, 0, customer_deck)
          resolve()
        })
      })
    }
  }

  var getSurveyTypefromUrl = function () {
    var path_parts = window.location.pathname.split('/').filter(x => x !== '')
    if (path_parts[3] === 'survey') {
      if (path_parts.length === 6) {
        return {
          type: 'survey-existing',
          id: path_parts[4],
          key: path_parts[5]
        }
      } else {
        return {
          type: 'survey-new'
        }
      }
    }
    return false
  }

  var getHotelIdFromUrl = function () {
    var path_parts = window.location.pathname.split('/').filter(x => x !== '')
    if (path_parts[1] === 'hotel') {
      return path_parts[2]
    }
  }

  var insertNamedCard = function (name) {
    return new Promise((resolve, reject) => {
      let card = {
        type: 'card-' + name, id: 0
      }
      store.dispatch('addCard', card).then((card_index) => resolve(card_index))
    })
  }

  var gotoNamedCard = function (name) {
    return new Promise((resolve, reject) => {
      var existing_card_index = findNamedCard(name)
      if (existing_card_index === false) {
        insertNamedCard(name).then((card_index) => resolve(card_index))
      } else {
        resolve(existing_card_index)
      }
    })
  }

  var findNamedCard = function (name) {
    for (var c in cards) {
      let card = cards[c]
      if (card.type === 'card-' + name) {
        return c
      }
    }
    return false
  }

  var getRemainingCardCount = function () {
    return decks[current_deck_index].getRemainingCardCount()
  }

  var loadExternalSurvey = function (surveyType) {
    return new Promise((resolve, reject) => {
      axios.get(base_url, {
        params: {
          type: 'survey_load_external',
          survey_id: store.state.surveyId,
          survey_key: store.state.surveyKey,
          survey_type: surveyType
        }
      }).then((response) => {
        Vue.set(store.state.external_questionaires, surveyType, response.data)
        resolve(response.data)
      })
    })
  }

  var updateSurveyProgress = function (progress_pct) {
    axios.get(base_url, {
      params: {
        type: 'survey_set_progress',
        survey_id: store.state.surveyId,
        survey_key: store.state.surveyKey,
        progress: Math.round(progress_pct)
      }})
  }

  var setReview = function (reviewData) {
    return new Promise((resolve, reject) => {
      axios.get(base_url, {
        params: {
          type: 'survey_set_review',
          survey_id: store.state.surveyId,
          survey_key: store.state.surveyKey,
          review: reviewData
        }
      }).then(function (response) {
        // groupId: "350", feedbackPositive: "pospos", feedbackNegative: "negneg"
        store.state.reviews[reviewData.groupId] = [
          { id: reviewData.groupId, type: 1, text: reviewData.feedbackPositive },
          { id: reviewData.groupId, type: 2, text: reviewData.feedbackNegative }
        ]
        resolve()
      })
    })
  }

  init()

  return {
    submitExternalSurvey: submitExternalSurvey,
    loadExternalSurvey: loadExternalSurvey,
    updateSurveyLanguage: updateSurveyLanguage,
    updateSurveyProgress: updateSurveyProgress,
    loadedExtendedQuestionaire: loaded_extended_questionaire,
    changeLocale: changeLocale,
    locale: locale,
    currentProgressPct: 0,
    maxProgressPct: 0,
    hotelId: hotel_id,
    selectedModules: [],
    customer: {},
    visit: {},
    reviews: reviews,
    external_questionaires: external_questionaires,
    loadingOverlay: false,
    surveyId: survey_id,
    surveyKey: survey_key,
    is_survey_finished: false,
    // answers: answers,
    hotelData: hotel_data,
    // questions: questions,
    decks: decks,
    mode: 'survey-creation',
    // cards: cst_survey_base_deck().cards,
    //            current_card_index: 0,
    current_deck_index: current_deck_index,
    loadSurvey: loadSurvey,
    initSurvey: initSurvey,
    createSurvey: createSurvey,
    finishSurvey: finishSurvey,
    loadExtendedSurvey: loadExtendedSurvey,
    gotoNamedCard: gotoNamedCard,
    getHotelData: getHotelData,
    getRemainingCardCount: getRemainingCardCount,
    setReview: setReview,
    answerQuestion: answerQuestion,
    answer_question: function (answer) {
      answers.push(answer)
      window.eventHub.$emit('card-next')
    },
    insertNamedCard: insertNamedCard,
    transition: 'slide',
    get_next_card_id: function () {
      var card_index = this.setNextCard()
      return card_index
    },
    getNextCard: function () {
      // if( store.state.survey.survey_status*1 == 5) {
      //     return {
      //         type: 'card-finished', id: 0
      //     }
      // }

      var card = this.decks[this.current_deck_index].getNextCard()
      if (!card) {
        this.current_deck_index++
        return this.getNextCard()
      }
      return card
    },
    setNextCard: function () {
      var card = this.getNextCard()
      // this.cards.push(this.getNextCard())
      store.commit('addCard', card)
      return this.cards.length - 1
    },
    hasNextCard: function () {
      let current_deck_has_card = this.decks[current_deck_index].hasNextCard()
      if (current_deck_has_card) {
        return true
      } else {
        return this.decks[current_deck_index + 1].hasNextCard()
      }
    },
    removeCard: function (card) {
      this.decks[this.current_deck_index].removeCard(card)
    },
    current_card_position: current_card_position,
    cards: cards,
    needsOverflow: false,
    languageLookup: language_lookup,
    languageLookupReverse: invert(language_lookup)
  }
}



// WEBPACK FOOTER //
// ./src/components/CstSurvey.js